"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _SNETTextfield = _interopRequireDefault(require("../SNETTextfield"));
var _keyCodes = require("../../../../utils/keyCodes");
var _TagsInputFieldModule = _interopRequireDefault(require("./TagsInputField.module.css"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TagsInputField = _ref => {
  let {
    error,
    tagsEntered,
    addTags,
    label,
    additionalInfo,
    description,
    extraInfo,
    infoMsg,
    disabled,
    required = false
  } = _ref;
  const [tags, setTags] = (0, _react.useState)(""); // Only to render in the chip component

  const handleAddTags = event => {
    if (event.keyCode !== _keyCodes.keyCodes.enter) {
      return;
    }
    setTags("");
    handleKeyEnterInTags(tags);
  };
  const handleKeyEnterInTags = () => {
    const tagsWithoutComa = tags.split(",");
    const localItems = [...tagsEntered];
    tagsWithoutComa.forEach(tag => {
      const tagWithoutSpace = tag.replace(/\s/g, "");
      if (!tagWithoutSpace) {
        return;
      }
      localItems.push(tagWithoutSpace);
      setTags("");
    });
    addTags(localItems);
  };
  const handleDeleteTag = tag => {
    const localItems = [...tagsEntered];
    const index = localItems.findIndex(el => el === tag);
    localItems.splice(index, 1);
    addTags(localItems);
  };
  const addedTags = _ref2 => {
    let {
      disabled
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _TagsInputFieldModule.default.addedTagsContainer
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: _TagsInputFieldModule.default.addTagLabel
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: _TagsInputFieldModule.default.addTagLabelInner
    }, "Added " + label)), /*#__PURE__*/_react.default.createElement("div", {
      className: _TagsInputFieldModule.default.card
    }, tagsEntered.map(tag => /*#__PURE__*/_react.default.createElement(_Chip.default, {
      className: _TagsInputFieldModule.default.chip,
      key: tag,
      label: tag,
      color: "primary",
      onDelete: () => handleDeleteTag(tag),
      disabled: disabled
    }))));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_TagsInputFieldModule.default.tagsContainer, disabled && _TagsInputFieldModule.default.disabled)
  }, /*#__PURE__*/_react.default.createElement(_SNETTextfield.default, {
    name: "tags",
    label: label,
    infoMsg: infoMsg,
    required: required,
    extraInfo: extraInfo,
    description: description,
    value: tags,
    onKeyUp: handleAddTags,
    onChange: e => setTags(e.target.value),
    InputProps: {
      endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
        position: "end"
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        disabled: disabled,
        onClick: handleKeyEnterInTags
      }, "+"))
    },
    disabled: disabled,
    error: error
  }), addedTags({
    disabled
  }), additionalInfo && /*#__PURE__*/_react.default.createElement("span", {
    className: _TagsInputFieldModule.default.addTagExtraInfo
  }, additionalInfo));
};
var _default = exports.default = TagsInputField;